import { callApi } from "../../helpers/apiHelper";

/**
 *
 * @param {number} id item id to fetch comments for
 * @param {number} skip how many contributions to skip
 * @param {number} top how many contributions to return
 * @returns an Item containing its associated comments
 */
export const getComments = async (
  implementationid,
  itemId,
  skip,
  top,
  sortAscending,
  sortByStarred,
  sortPinned,
  showContributionsWithPhotos
) => {
  return await callApi(`api/item/${implementationid}/${itemId}`, {
    params: {
      skip,
      top,
      sortAscending,
      starred: sortByStarred,
      sortPinned,
      showContributionsWithPhotos
    },
  });
};

/**
 *
 * @param {guid} implementationId
 * @param {string} externalId
 * @returns item data for creating a new item.
 * Currently this method hits the test endpoint for nhle. Remove the /TestXML/ from the url to use the endpoints set in the db.
 */
export const getNewItem = async (implementationid, externalId) => {
    const newItem = await callApi(`api/ExternalApi/${implementationid}/${externalId}`, {});
    if (!newItem.id) {
        console.error("No item was found when getting the item from the external data")
    }
    return newItem; 
};

/**
 * Gets an array of Item resources intended for use in populating pins on a map
 * where we do not have an ESRI feature layer to use. NOT FOR NHLE!!!
 * @param {guid} implementationId.
 */
export const getAllItemsFromExternalData = async (implementationid) => {
  return await callApi(`api/ExternalApi/${implementationid}/`, {});
};

/**
 * Gets the campaign using the implementationid & campaignid
 * @param {guid} implementationId 
 * @param {guid} campaignId 
 * @returns 
 */
export const getCampaign = async (implementationId, campaignId) => {
  let apiResponse = await callApi(`api/Campaign/${implementationId}/${campaignId}`, {});
  return apiResponse; 
}

/**
 *
 * @param {number} id item id to fetch media for
 * @param {number} skip how many media items to skip
 * @param {number} top how many media items to return
 * @returns a list of media with their associated comment
 */
export const getMedia = async (id, skip, top) => {
  return await callApi(`api/media/${id}`, { params: { skip, top } });
};

/**
 *
 * @param {number} id user id to fetch media for
 * @param {number} statusId status id to fetch media for
 * @param {number} skip how many media items to skip
 * @param {number} top how many media items to return
 * @returns a list of media with their associated comment
 */
export const getProfileMedia = async (memberId, statusId, skip, top) => {
  return await callApi(`api/profileMedia/${memberId}/${statusId}`, { params: { skip, top } });
};


/**
 *
 * @param {object} data the form data for creating a contribution
 * @returns
 */
export const postContribution = async (data) => {
  return await callApi("odata/comment", {
    options: {
      method: "POST",
      body: JSON.stringify(data),
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

/**
 *
 * @param {object} data the form data for updating a contribution
 * @returns
 */
export const putContribution = async (data) => {
  return await callApi("odata/comment", {
    options: {
      method: "PUT",
      body: JSON.stringify(data),
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getImplementation = async (implementationid) => {
  try {
    let result = await callApi(
      `odata/Implementation?$filter=id eq ${implementationid}`
    );
    return result.value[0];
  } catch {
    return null;
  }
};

export const lookForItemByAddress = async (implementationid, address) => {
  try {
    address = address.replace("'", "''");
    let result = await callApi(
      `odata/item?$filter=implementationId eq ${implementationid} and contains(location/address,'${address}')`
    );
    return result.value[0];
  } catch {
    return null;
  }
};
